import React, { useEffect, useState } from "react";
import { IInvoice } from "../../interfaces/IInvoice";
import { AppBar, Box, Button, CircularProgress, Dialog, DialogContent, IconButton, Slide, TableCell, TableRow, Toolbar, Typography } from "@mui/material";
import { IInvoiceState } from "../../interfaces/IInvoiceState";
import { IInvoiceType } from "../../interfaces/IInvoiceType";
import { InvoiceStateChip } from "./InvoiceStateChip";
import { Delete, Download, Edit, Search } from "@mui/icons-material";
import { TransitionProps } from "@mui/material/transitions";
import { GridCloseIcon } from "@mui/x-data-grid";
import { InvoiceEditor } from "./InvoiceEditor";
import { useDeleteInvoice, useGenerateInvoiceDocument, useUpdateInvoice } from "../../hooks/data/data_invoice";
import { IDocument } from "../../interfaces/IDocument";
import { ErrorTryRefetch } from "../core/ErrorTryRefetch";
import { InvoiceEditDialog } from "./InvoiceEditDialog";
import { IRecipientOfPayment } from "../../interfaces/IRecipientOfPayment";


interface IProps {
    invoice: IInvoice;
    invoices: IInvoice[];
    bankAccounts: IRecipientOfPayment[];


    invStates: IInvoiceState[];
    invTypes: IInvoiceType[];

    setFeetback: Function;
    refetchFunction: Function;
}



export const InvoiceRow:React.FC<IProps> = ({
    invoice,
    invoices,
    bankAccounts,
    invStates,
    invTypes,
    setFeetback,
    refetchFunction

}) => {
    const [editInv,setEditInv] = useState(invoice);
    //
    const [isOpenEdit,setIsOpenEdit] = useState(false);
    //

    //
    const {invoiceDocument,isFetechingInvoiceDocument,isLoadingInvoiceDocument,refetechInvoiceDocument} = useGenerateInvoiceDocument(invoice.id);
    //
    const [isOpenShowDocument,setIsOpenShowDocument] = useState(false);
    const [invDocument,setInvDocument] = useState<IDocument|null>(invoice.Document);
    //
    const [showLoadingDownload,setShowLoadingDownload] = useState(false);
    //
    const { deleteInvoice, isPendingDeleteInvoice } = useDeleteInvoice();

    useEffect(() => {
        if (invoiceDocument !== undefined) {
            setInvDocument(invoiceDocument)
        }
    },[invoiceDocument])

    const handleOpen = () => {
        setEditInv(invoice);
        setIsOpenEdit(true);
    }

    const downloadFile = (localDoc:IDocument) => {
        if (localDoc !== null && localDoc.data) {
            const blob = new Blob([Uint8Array.from(atob(localDoc.data), c => c.charCodeAt(0))], {
                type: 'application/pdf',
            });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = localDoc.file_name || 'document.pdf';
            a.click();
            URL.revokeObjectURL(url);
        }
        setShowLoadingDownload(false);
    }

    const handleShowDocument = async () => {
        
        if (editInv.Document === null) {
            setIsOpenShowDocument(true);
            const localFile = await refetechInvoiceDocument();
            if (!localFile.data) {
                console.error("Dokument konnte nicht geladen werden.");
                return;
            }
            setInvDocument(localFile.data);
        } else {
            setInvDocument(editInv.Document);
        }
        
    }

    const handleDownload = async () => {
        setShowLoadingDownload(true);
        
        if (editInv.Document === null) {
            const localFile = await refetechInvoiceDocument();
            if (!localFile.data) {
                console.error("Dokument konnte nicht geladen werden.");
                return;
            }
            //setInvDocument(localFile.data);
            downloadFile(localFile.data);
        } else {
            downloadFile(editInv.Document)
        }
    }

    const handleRemove = async () => {
        try {
            await deleteInvoice(editInv.id);
            setFeetback({
                open: true,
                message: "Erfolgreich gelöscht!",
                severity: "success"
            })
            refetchFunction();
        } catch (error) {
            setFeetback({
                open: true,
                message: "Es ist ein Fehler aufgetretten!",
                severity: "error"
            })
        }
    }


    return(
        <>

            {(isPendingDeleteInvoice) &&
                <Dialog open>
                    <DialogContent>
                        Wirt gelöscht...
                    </DialogContent>
                </Dialog>
            }
            
            {(showLoadingDownload && isLoadingInvoiceDocument) &&
                <Dialog open>
                    <DialogContent>
                        Generiere Dokument(e)...
                    </DialogContent>
                </Dialog>
            }

            {(isOpenShowDocument) &&
                <Dialog
                    open
                    onClose={() => setIsOpenShowDocument(false)}
                    maxWidth="md"
                    fullWidth
                >
                    <DialogContent>
                        { (isLoadingInvoiceDocument || isFetechingInvoiceDocument)
                            ? <CircularProgress/>
                            : (!invDocument) 
                            ? <ErrorTryRefetch refetchFunction={() => refetechInvoiceDocument()}/>
                            : <iframe 
                                src={`data:application/pdf;base64,${invDocument.data}`}
                                title={invDocument.file_name}
                                name={invDocument.file_name}
                            />
                        }
                    </DialogContent>
                </Dialog>
            }

            <InvoiceEditDialog
                key={`invoice-dialog-editor-${invoice.id}`}
                editInv={editInv}
                setEditInv={setEditInv}
                invoices={invoices}
                bankAccounts={bankAccounts}
                invTypes={invTypes}
                invStates={invStates}
                isOpenEdit={isOpenEdit}
                setFeetback={setFeetback}
                setIsOpenEdit={setIsOpenEdit}
                refetchFunction={refetchFunction}
            />

            <TableRow>
                <TableCell>
                    {invoice.invoice_number}
                </TableCell>
                <TableCell>
                    <InvoiceStateChip
                        invoice={invoice}
                        invoiceState={invStates}
                    />
                </TableCell>
                <TableCell>
                    {invoice.title}
                </TableCell>
                <TableCell>
                    {(invoice.invoice_send_at === null) ? "-" : invoice.invoice_send_at}
                </TableCell>
                <TableCell>
                    {(invoice.total*(1+invoice.vat)).toLocaleString('de-DE', {
                        style: 'currency',
                        currency: 'EUR',
                    })}
                </TableCell>
                <TableCell>
                    <IconButton
                        size="small"
                        onClick={handleOpen}
                    >
                        <Edit/>
                    </IconButton>
                    <IconButton
                        size="small"
                        onClick={handleShowDocument}
                    >
                        <Search/>
                    </IconButton>
                    <IconButton
                        size="small"
                        onClick={handleDownload}
                    >
                        <Download/>
                    </IconButton>
                    {(invoice.invoice_number === "") &&
                        <IconButton
                            size="small"
                            onClick={handleRemove}
                        >
                            <Delete/>
                        </IconButton>
                    }
                </TableCell>
            </TableRow>
        </>
    )
}